import React from "react";

import Navbar from "./Navbar";
import HeroSection from "./HeroSection";
import FeatureSection from "./FeatureSection";
import CallToAction from "./CallToAction";
import WhyChooseUs from "./WhyChooseUs";
import FaqSection from "./FaqSection";
import Footer from "./Footer";

export default function MainPage() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <FeatureSection />
      <CallToAction />
      <WhyChooseUs />
      <FaqSection />
      <Footer />
    </>
  );
}
